"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Course = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var course_card_1 = require("../../components/entities/course-card");
var course_details_layout_1 = require("../../components/entities/course-details-layout");
var course_details_banner_1 = require("../../components/entities/course-details-banner");
exports.Course = {
  name: 'Course',
  useConversation: true,
  useFollowers: true,
  useModerators: true,
  useConnections: true,
  autoRoutes: ['details', 'list', 'update', 'create'],
  usePlatformActivity: true,
  useSlices: true,
  useSpaces: true,
  platformActivity: {
    tab: 'own'
  },
  filters: {
    fields: {
      programs: {
        entityTypeName: 'Program'
      }
    }
  },
  list: {
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      participants { ...EntityValueFields }\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      registrationUrl\n      isCurrentUserParticipating\n      description { plainTruncated: plain(truncate: { words: 50 }) plain ...ContentNodeFields }\n      lessons { id }\n      program { id name slug }\n      startDate\n    "], ["\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      participants { ...EntityValueFields }\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      registrationUrl\n      isCurrentUserParticipating\n      description { plainTruncated: plain(truncate: { words: 50 }) plain ...ContentNodeFields }\n      lessons { id }\n      program { id name slug }\n      startDate\n    "])))
  },
  components: {
    card: course_card_1.CourseCard,
    details: course_details_layout_1.CourseDetailsLayout,
    banner: course_details_banner_1.CourseDetailsBanner
  },
  form: {
    fieldsMemoize: false,
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'lessons',
      label: '{{LESSONS}}'
    }, {
      name: 'activity'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'places'
    }, {
      name: 'library'
    }, {
      name: 'community'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner',
        fieldSet: 'overview'
      },
      startDate: {
        type: 'date',
        description: 'When does this {{COURSE}} start?',
        fieldSet: 'overview'
      },
      endDate: {
        type: 'date',
        description: 'When does this {{COURSE}} finish?',
        fieldSet: 'overview'
      },
      fileAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset',
        fieldSet: 'library',
        description: "Does this {{COURSE}} have any associated {{FILE_ASSETS}}?"
      },
      imageAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library',
        description: "Does this {{COURSE}} have any {{IMAGE_ASSETS}}?"
      },
      description: {
        type: 'description'
      },
      url: {
        type: 'url',
        fieldSet: 'overview'
      },
      isVirtual: {
        type: 'boolean'
      },
      presenters: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        label: process.env.COURSE_PRESENTERS_LABEL || 'Presenters',
        description: 'Who are the presenters of this {{COURSE}}?'
      },
      providers: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        label: 'Providers',
        description: 'Which organisations are providing this {{COURSE}}?'
      },
      roles: {
        type: 'linkedTable',
        entityTypeName: 'CourseRole',
        label: '{{PEOPLE}}',
        description: "Are there other key {{PEOPLE}} involved in this {{COURSE}}?",
        fieldSet: 'overview'
      },
      registrationUrl: {
        type: 'text',
        description: "Where can people register for this {{COURSE}}?"
      },
      lessons: {
        type: 'linkedTable',
        description: 'Create one or more {{LESSONS}} for this {{COURSE}}',
        entityTypeName: 'Lesson',
        fieldSet: 'lessons'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      documents: {
        type: 'linkedMultiple',
        entityTypeName: 'Document',
        fieldSet: 'activity'
      },
      locations: {
        type: 'linkedMultiple',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      economies: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        fieldSet: 'places'
      },
      quotes: {
        type: 'linkedMultiple',
        entityTypeName: 'Quote',
        fieldSet: 'library'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      id\n      name\n      slug\n      description { \n        id text html\n        embeds { ...EntityValueFields }  \n      }\n      isVirtual\n      startDate\n      endDate\n      url\n      places { id name slug latitude longitude address1 address2 banner { id name slug title description { text } alternateText openGraph { id image { id url } } } city { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n\n      isCurrentUserParticipating\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      participants { ...EntityValueFields }\n\n      program { id name slug }\n      programs { ...EntityValueFields }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n      fileAssets { ...FileAssetValueFields }\n      podcasts { ...FileAssetValueFields }\n      imageAssets { ...EntityValueFields image { id url type width height } }\n\n      lessons { \n        ...EntityValueFields\n        startDate\n        endDate\n        presenters { id name }\n        hours\n      }\n      videos { ...EntityValueFields url }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      links { ...EntityValueFields url }\n      documents { ...EntityValueFields }\n      quotes { ...EntityValueFields }\n      roles { ...EntityValueFields }\n    "], ["\n      id\n      name\n      slug\n      description { \n        id text html\n        embeds { ...EntityValueFields }  \n      }\n      isVirtual\n      startDate\n      endDate\n      url\n      places { id name slug latitude longitude address1 address2 banner { id name slug title description { text } alternateText openGraph { id image { id url } } } city { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n\n      isCurrentUserParticipating\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      participants { ...EntityValueFields }\n\n      program { id name slug }\n      programs { ...EntityValueFields }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n      fileAssets { ...FileAssetValueFields }\n      podcasts { ...FileAssetValueFields }\n      imageAssets { ...EntityValueFields image { id url type width height } }\n\n      lessons { \n        ...EntityValueFields\n        startDate\n        endDate\n        presenters { id name }\n        hours\n      }\n      videos { ...EntityValueFields url }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      links { ...EntityValueFields url }\n      documents { ...EntityValueFields }\n      quotes { ...EntityValueFields }\n      roles { ...EntityValueFields }\n    "])))
  }
};
var templateObject_1, templateObject_2;